<template>
  <img
    src="@/assets/img/drop-arrow.svg"
    class="drop-arrow"
    :class="[rotate && 'rotate-arrow', size]"
  />
</template>

<script>
export default {
  props: {
    rotate: { type: Boolean, default: false },
    size: { type: String, default: "full" },
  },
};
</script>

<style scoped>
.full {
  width: 44px;
  height: 44px;
}

.half {
  width: 22px;
  height: 22px;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.drop-arrow {
  transition: 0.3s;
}
</style>
